<template>
    <module-card :nextDisabled="nextDisabled">
        <Carousel :length="strategies.length" @change="change">
            <template v-slot:default="slotProps">
                <div>
                    <v-img class="mx-auto" :max-width="200" :src="strategies[slotProps.index].img"></v-img>
                    <span class="font-weight-bold">{{ strategies[slotProps.index].title }}</span>
                    <div v-html="strategies[slotProps.index].text"></div>
                </div>
            </template>
        </Carousel>
    </module-card>
</template>

<script>
    import { every } from 'lodash';

    export default {
        data() {
            return {
                strategies: [
                    {
                        id: 1,
                        img: require('@/assets/4WaystoManageStigma/passing.png'),
                        title: 'Passing',
                        text: `
                            <p>You feel ashamed by the hate against you and your Non-VIP group, so you keep your identity to yourself and try to “pass” as a member of a more “VIP” group.  The term “passing” originally referred to light-skinned African-Americans who could “pass” as white and avoid discrimination and prejudice.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 2,
                        img: require('@/assets/4WaystoManageStigma/towel.png'),
                        title: 'Throwing in the Towel',
                        text: `
                            <p>You feel ashamed by the hate against you and your Non-VIP group, so you avoid (or quit doing) all things related to this Non-VIP group.  For example, if you’re told over and over again that having sex with another guy is gross, you start to believe it, and decide to stop being true to yourself.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 3,
                        img: require('@/assets/4WaystoManageStigma/masks.png'),
                        title: 'Playing the Part',
                        text: `
                            <p>You realize there’s hate against you and your Non-VIP group. Instead of fighting it, you act how people expect you to act.  You might even exaggerate it —even if it means you look foolish.  It’s like calling yourself a fag before anyone else does.  “Playing the Part” makes people think you make fun of yourself enough so they don’t have to, which is one way to manage stigma and shame.</p>
                        `,
                        visited: false
                    },
                    {
                        id: 4,
                        img: require('@/assets/4WaystoManageStigma/fist.png'),
                        title: 'Standing United',
                        text: `
                            <p>You acknowledge yourself as a member of a Non-VIP group, but you decide to fight hard to eliminate the FAKE label of Non-VIP and stand up for your rights and the rights of those around you. </p>
                        `,
                        visited: false
                    }
                ]
            };
        },
        methods: {
            change(index) {
                this.strategies[index].visited = true;
            },
            nextDisabled() {
                return !every(this.strategies, (s) => {
                    return s.visited;
                });
            }
        }
    };
</script>

<style scoped>
    .unselected {
        opacity: 0.5;
    }
</style>
